export default __webpack_public_path__ + "static/3_28-4f918d287203fb95d5a834d488b37387.png";